export default {
    title: "Kategorien",
    name: "Bezeichnung",
    description: "Beschreibung",
}